<template>
  <v-container class="mt-4 pa-0">
    <v-flex>
      <v-card
        color="primary"
        class="elevation-1"
        :style="{ textAlign: 'center' }"
        v-if="!!repair.length"
      >
        <v-toolbar color="primary" flat>
          <v-tooltip bottom>
            <v-toolbar-side-icon slot="activator" @click="reset()" icon>
              <v-icon>arrow_back</v-icon>
            </v-toolbar-side-icon>
            <span>Return to Barcode</span>
          </v-tooltip>
          <h2>
            <span class="hidden-xs-only">Repair Reference -</span>

            <a
              target="new"
              :href="
                `https://ops.bohmtech.com/web#id=${repair[0].id}&view_type=form&model=mrp.repair`
              "
              :style="{ color: '#F04E23', textDecoration: 'none' }"
              class="ml-2"
              >{{ repair[0].name }}</a
            >
          </h2>
          <v-spacer></v-spacer>

          <h3 class="hidden-xs-only">{{ repair[0].product_id[1] }}</h3>
        </v-toolbar>
        <div v-if="repair[0].x_mrp_passed === 'FAILED'">
          <v-card
            color="primary"
            class="mb-5 elevation-0"
            :style="{ textAlign: 'center' }"
          >
            <h2 class="mt-2">This repair order has a failed step!</h2>
            <v-btn color="primary" @click="reset()">Go Home</v-btn>
          </v-card>
        </div>

        <div v-else-if="repair[0].x_mrp_passed === 'INCOMPLETE'">
          <v-card
            color="primary"
            class="mb-5 elevation-0"
            :style="{ textAlign: 'center' }"
          >
            <h2 class="mt-2">This repair order does not have a testing step!</h2>
            <v-btn color="primary" @click="reset()">Go Home</v-btn>
          </v-card>
        </div>

        <div v-else-if="repairState != 'done'">
          <v-card
            color="primary"
            class="mb-5 elevation-0"
            :style="{ textAlign: 'center' }"
          >
            <v-stepper v-model="currentStep" class="elevation-0 mx-5">
              <v-stepper-header class="elevation-0">
                <template v-for="(surface, sIndex) in surfaces">
                  <v-stepper-step
                    :key="`${sIndex + 1}-head`"
                    :step="sIndex + 1"
                    :complete="currentStep > sIndex + 1"
                    >{{ surface.code }}</v-stepper-step
                  >
                  <v-divider
                    v-if="sIndex != surfaces.length - 1"
                    :key="`${sIndex}-divider`"
                  />
                </template>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content
                  v-for="(surface, sIndex) in surfaces"
                  :key="`${sIndex + 1}-card`"
                  :step="sIndex + 1"
                >
                  <v-card
                    color="primary"
                    class="mb-5 elevation-0"
                    height="550px"
                  >
                    <div
                      :style="{ textAlign: 'center' }"
                      v-if="surface.surface"
                    >
                      <h2 class="mb-3" v-if="surface.code">
                        {{ surface.name }} - ({{ surface.code }})
                      </h2>
                    </div>

                    <v-layout v-if="surface.surface" row wrap justify-center>
                      <v-flex xs12 md8>
                        <div
                          v-for="(question, qIndex) in surfaceQuestions"
                          :key="qIndex"
                        >
                          <v-text-field
                            v-if="values.length"
                            :name="`question-${sIndex + 1}-${qIndex + 1}`"
                            type="tel"
                            v-model="
                              values[sIndex - 1][
                                Object.keys(values[sIndex - 1])[qIndex]
                              ]
                            "
                            mask="##"
                            color="secondary"
                            outline
                            height="35"
                          >
                            <template v-slot:label>
                              <span
                                class="py-4"
                                :style="{ fontSize: '16px' }"
                                >{{ question }}</span
                              >
                            </template>
                          </v-text-field>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout
                      v-else-if="surface.code == 'Other'"
                      row
                      wrap
                      justify-center
                    >
                      <v-flex xs6 v-if="otherStep == 1">
                        <h2 class="mb-3">Missing / Non-OEM Parts</h2>
                        <ul style="text-align: left">
                          <li>
                            Non-OEM or custom parts on any surface are not
                            allowed
                          </li>
                          <li>
                            No part on the Missing Parts list allowed to be
                            missing
                          </li>
                          <li>
                            Replace all Replaceable parts on the Missing
                            Components Replacement List to make device whole
                          </li>
                        </ul>
                      </v-flex>

                      <v-flex xs6 v-if="otherStep == 1">
                        <h2 class="mb-3">
                          Bent Device/Lifted Lens or Back Cover Separation
                        </h2>
                        <ul style="text-align: left">
                          <li>
                            The device is not bent.
                          </li>
                          <li>
                            The device does not have its back cover separated.
                          </li>
                        </ul>
                      </v-flex>

                      <v-flex xs6 v-if="otherStep == 1">
                        <h2 class="mb-3">
                          Connectors
                        </h2>
                        <ul style="text-align: left">
                          <li>Pins must be present and straight</li>
                          <li>Connector housing must not be damaged</li>
                          <li>
                            Where required, all ports must be plugged
                          </li>
                          <li>
                            No corrosion allowed
                          </li>
                        </ul>
                      </v-flex>

                      <v-flex xs6 v-if="otherStep == 1">
                        <h2 class="mb-3">
                          Liquid Damage Indicator (LDI)
                        </h2>
                        <ul style="text-align: left">
                          <li>There are no signs of liquid damage.</li>
                        </ul>
                      </v-flex>

                      <v-flex xs6 v-if="otherStep == 2">
                        <h2 class="mb-3">
                          Logos
                        </h2>
                        <ul style="text-align: left">
                          <li>
                            Must be securely attached to the device
                          </li>

                          <li>Missing logos are not allowed</li>
                          <li>
                            Cosmetic defects are allowed in accordance with the
                            surface classification where the logo is located
                          </li>
                        </ul>
                      </v-flex>

                      <v-flex xs6 v-if="otherStep == 2">
                        <h2 class="mb-3">
                          Keys / Toggles / Soft Keys / Navigation Buttons
                        </h2>
                        <ul style="text-align: left">
                          <li>
                            Must not be pushed under the cover
                          </li>
                          <li>Must not be worn or faded</li>
                          <li>
                            Must be properly seated in housing and on board
                          </li>
                        </ul>
                      </v-flex>
                      <v-flex xs6 v-if="otherStep == 2">
                        <h2 class="mb-3">
                          SIM / SD card tray
                        </h2>
                        <ul style="text-align: left">
                          <li>
                            The SIM card and SD card (if applicable) should sit
                            properly in its place
                          </li>
                          <li>
                            SIM card trays that are missing the water resistant
                            rubber seal are not acceptable
                          </li>
                          <li>
                            For a mismatched color or damaged SIM tray, replace
                            the tray with a good replacement tray
                          </li>
                        </ul>
                      </v-flex>

                      <v-flex xs6 v-if="otherStep == 2">
                        <h2 class="mb-3">
                          Labels / Etching
                        </h2>
                        <ul style="text-align: left">
                          <li>
                            Legible IMEI/ESN label and Part Number/SKU
                          </li>
                          <li>
                            Not worn or faded
                          </li>
                          <li>
                            All OEM etching/engraving must be visible
                          </li>
                          <li>
                            OEM etching/engraving can be faint, but must be
                            present
                          </li>
                          <h3>
                            NOT PERMITTED:
                          </h3>

                          <li>
                            Device label or back housing etching that displays:
                            ""Refurbished by (any third party name)”
                          </li>
                          <li>
                            Labels on the device that indicate it is not for
                            resale. This includes, but is not limited to,
                            messages that read “NOT FOR SALE” and “DEMO”"
                          </li>
                        </ul>
                      </v-flex>
                    </v-layout>

                    <v-layout v-else row wrap justify-center>
                      <div>
                        <h1 class="mb-3">Final Grade</h1>
                        <div
                          class="grade-circle"
                          :style="{ color: totalGrade.color }"
                        >
                          {{ totalGrade.text }}
                        </div>
                      </div>
                    </v-layout>

                    <div
                      class="mt-4"
                      style="position: absolute; bottom: 0;left: 0; right: 0"
                    >
                      <h2 v-if="surface.code == 'Other'">
                        Is the above criteria met?
                      </h2>
                      <v-btn
                        color="success"
                        @click="
                          otherStep != 2 ? handleOther() : currentStep++;
                          failedOther = false;
                        "
                        v-if="surface.code == 'Other'"
                        >Yes</v-btn
                      >
                      <v-btn
                        color="error"
                        v-if="surface.code == 'Other'"
                        @click="
                          currentStep = 6;
                          failedOther = true;
                        "
                        >No</v-btn
                      >
                      <v-btn
                        color="primary"
                        v-if="sIndex + 1 != surfaces.length && currentStep != 1"
                        :disabled="disableButton(sIndex)"
                        @click.native="continueToNextStep(sIndex)"
                        >Continue</v-btn
                      >
                      <v-btn
                        color="primary"
                        v-else-if="currentStep != 1"
                        @click.native="submitGrade"
                        >Submit Grade</v-btn
                      >
                      <v-btn
                        flat
                        @click.native="
                          sIndex != 0
                            ? failedOther
                              ? (currentStep = 1)
                              : goBack()
                            : $router.push('/ipad-grading')
                        "
                        >{{ sIndex != 0 ? "Go Back" : "Cancel" }}</v-btn
                      >
                    </div>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card>
        </div>

        <div v-else>
          <v-card
            color="primary"
            class="mb-5 elevation-0"
            :style="{ textAlign: 'center' }"
          >
            <h2 class="mt-2">This repair order has been completed!</h2>
            <v-card height="550px" class="mt-5" color="primary" flat>
              <v-select
                :items="allPrinters"
                v-model="selectedPrinter"
                color="secondary"
                label="Select Printer"
                box
                :style="{ width: '50%', margin: 'auto' }"
              ></v-select>
              <v-btn color="secondary" @click="printLabel()"
                >Print Sort Label</v-btn
              >
              <v-btn color="primary" @click="reset()">Go Home</v-btn>
              <v-card-text
                v-if="currentStep > 1"
                class="mx-auto mt-4"
                :style="{ width: '50%', color: '#F04E23' }"
              >
                <h1 v-if="goToVerizon">Send to Verizon</h1>
                <h1 v-if="goToRevShare">Send to Rev Share</h1>
              </v-card-text>
            </v-card>
          </v-card>
        </div>
      </v-card>
    </v-flex>

    <v-dialog
      v-model="sizeDialog"
      width="60%"
      persistent
      :style="{ overflow: 'hidden' }"
      transition="dialog-transition"
    >
      <v-card
        color="primary"
        :style="{
          height: '50vh',
          overflow: 'hidden',
          textAlign: 'center',
          width: '100%'
        }"
        v-if="currentSizeStatements.length"
      >
        <v-stepper v-model="sizeStep" class="elevation-0 mx-5">
          <v-stepper-header class="elevation-0">
            <template v-for="(item, sIndex) in currentSizeStatements">
              <v-stepper-step
                :key="`${sIndex + 1}-head-size`"
                :step="sIndex + 1"
                :complete="sizeStep > sIndex + 1"
                >{{ item.name }}</v-stepper-step
              >
              <v-divider
                v-if="sIndex != currentSizeStatements.length - 1"
                :key="`${sIndex}-divider-size`"
              />
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content
              v-for="(question, qIndex) in currentSizeStatements"
              :step="qIndex + 1"
              :key="qIndex"
            >
              <h2 class="mb-3">{{ question.statement }}</h2>
              <div v-for="(item, bIndex) in question.statements" :key="bIndex">
                <v-btn
                  class="mx-auto"
                  :style="{ width: '80%' }"
                  @click="valueSelected(bIndex, question)"
                  >{{ item }}</v-btn
                >
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";

export default {
  name: "watch",

  data() {
    return {
      currentStep: 1,
      otherStep: 1,
      repairState: "",
      values: [],
      failedOther: false,
      goToRevShare: false,
      goToVerizon: false,
      surfaceQuestions: [
        "How many Scratches/Scuffs?",
        "How many Nicks/Gouges/Chips?",
        "How many Dents?",
        "How many Cracks?",
        "How many Discolorations?"
      ],
      surfaces: [
        {
          name: "Other",
          code: "Other",
          surface: false
        },
        {
          name: "Full front glass + camera lens",
          code: "AA",
          surface: true
        },
        {
          name: "Bezel as seen from the front + Home key/Speaker/Ear Piece",
          code: "A",
          surface: true
        },
        {
          name: "Sides of device",
          code: "B",
          surface: true
        },
        {
          name: "Back of device except camera lens",
          code: "C",
          surface: true
        },
        {
          name: "Complete",
          code: "Complete",
          surface: false
        }
      ],
      sizeQuestions: [
        {
          scratch: [
            "Smaller than 15mm",
            "Smaller than 45mm but larger than 15mm",
            "Larger than 45mm"
          ]
        },
        {
          scratch: [
            "Smaller than 15mm",
            "Smaller than 45mm but larger than 15mm",
            "Larger than 45mm"
          ],
          nick: [
            "Smaller than 1mm",
            "Smaller than 2mm but larger than 1mm",
            "Larger than 2mm"
          ],
          dent: ["Smaller than 1mm", "Larger than 1mm"],
          discoloration: ["Smaller than 3mm", "Larger than 3mm"]
        },
        {
          scratch: [
            "Smaller than 15mm",
            "Smaller than 25mm but larger than 15mm",
            "Larger than 25mm"
          ],
          nick: [
            "Smaller than 1mm",
            "Smaller than 2mm but larger than 1mm",
            "Smaller than 3mm but larger than 2mm",
            "Larger than 3mm"
          ],
          dent: [
            "Smaller than 1mm",
            "Smaller than 2mm but larger than 1mm",
            "Smaller than 3mm but larger than 2mm",
            "Larger than 3mm"
          ],
          discoloration: ["Smaller than 5mm", "Larger than 5mm"]
        },
        {
          scratch: [
            "Smaller than 25mm",
            "Smaller than 40mm but larger than 25mm",
            "Larger than 40mm"
          ],
          nick: [
            "Smaller than 2mm",
            "Smaller than 3mm but larger than 2mm",
            "Larger than 3mm"
          ],
          dent: ["Smaller than 3mm", "Larger than 3mm"],
          discoloration: ["Smaller than 5mm", "Larger than 5mm"]
        }
      ],
      sizeStatement: [
        "The largest scratch/scuff is...",
        "This largest nick/gouge/chip/dent is...",
        "The largest dent is...",
        "The largest discoloration is..."
      ],
      currentSizeStatements: [],
      grades: [
        { text: "A+", value: 100, color: "#339a00" },
        { text: "A", value: 90, color: "#339a00" },
        { text: "B", value: 80, color: "yellow" },
        { text: "D+", value: 60, color: "red" }
      ],
      sizeDialog: false,
      sizeStep: 1,
      failedLength: false,
      noAPlus: false
    };
  },

  mixins: [LoginCheck],

  async beforeMount() {
    await this.searchServices({ serial: this.$route.params.id });

    this.surfaces.forEach(surface => {
      if (surface.surface)
        this.values.push({
          scratch: "",
          nick: "",
          dent: "",
          crack: "",
          discoloration: ""
        });
    });
    if (this.repair.length) {
      this.repairState = this.repair[0].state;
    } else {
      this.reset();
    }

    await this.getAllPrinters();
  },

  destroyed() {
    this.$store.commit("repair/setRepair", []);
  },
  watch: {},
  computed: {
    ...mapGetters({
      repair: "repair/getRepair",
      storedPrinter: "repair/getSelectedPrinter",
      allPrinters: "repair/getAllPrinters",
      user: "app/getUser"
    }),

    selectedPrinter: {
      get() {
        return this.storedPrinter;
      },
      set(val) {
        return this.$store.commit("repair/setSelectedPrinter", val);
      }
    },

    AAGrade() {
      if (this.values.length) {
        let values = this.values[0];
        const { scratch, nick, dent, crack, discoloration } = values;
        let grade = 0;
        if (
          scratch <= 3 &&
          nick == 0 &&
          dent == 0 &&
          crack == 0 &&
          discoloration == 0 &&
          !this.noAPlus
        ) {
          grade = 0;
        } else if (
          scratch <= 6 &&
          nick == 0 &&
          dent == 0 &&
          crack == 0 &&
          discoloration == 0
        ) {
          grade = 1;
        } else if (
          scratch <= 8 &&
          nick == 0 &&
          dent == 0 &&
          crack == 0 &&
          discoloration == 0
        ) {
          grade = 2;
        } else {
          grade = 3;
        }
        return this.grades[grade];
      } else return 3;
    },

    AGrade() {
      if (this.values.length) {
        let values = this.values[1];
        const { scratch, nick, dent, crack, discoloration } = values;
        let grade = 0;
        if (
          scratch <= 3 &&
          nick == 0 &&
          dent == 0 &&
          crack == 0 &&
          discoloration == 0 &&
          !this.noAPlus
        ) {
          grade = 0;
        } else if (
          scratch <= 6 &&
          nick <= 2 &&
          dent == 0 &&
          crack == 0 &&
          discoloration == 0
        ) {
          grade = 1;
        } else if (
          scratch <= 8 &&
          nick <= 4 &&
          dent <= 2 &&
          crack == 0 &&
          discoloration <= 4
        ) {
          grade = 2;
        } else {
          grade = 3;
        }
        return this.grades[grade];
      } else return 3;
    },

    BGrade() {
      if (this.values.length) {
        let values = this.values[2];
        const { scratch, nick, dent, crack, discoloration } = values;
        let grade = 0;
        if (
          scratch <= 4 &&
          nick <= 2 &&
          dent <= 2 &&
          crack == 0 &&
          discoloration == 0 &&
          !this.noAPlus
        ) {
          grade = 0;
        } else if (
          scratch <= 6 &&
          nick <= 4 &&
          dent <= 2 &&
          crack == 0 &&
          discoloration <= 6
        ) {
          grade = 1;
        } else if (
          scratch <= 10 &&
          nick <= 4 &&
          dent <= 3 &&
          crack == 0 &&
          discoloration <= 6
        ) {
          grade = 2;
        } else {
          grade = 3;
        }
        return this.grades[grade];
      } else return 3;
    },

    CGrade() {
      if (this.values.length) {
        let values = this.values[3];
        const { scratch, nick, dent, crack, discoloration } = values;
        let grade = 0;
        if (
          scratch <= 4 &&
          nick <= 0 &&
          dent <= 2 &&
          crack == 0 &&
          discoloration == 0 &&
          !this.noAPlus
        ) {
          grade = 0;
        } else if (
          scratch <= 6 &&
          nick <= 2 &&
          dent <= 2 &&
          crack == 0 &&
          discoloration <= 4
        ) {
          grade = 1;
        } else if (
          scratch <= 10 &&
          nick <= 3 &&
          dent <= 3 &&
          crack == 0 &&
          discoloration <= 4
        ) {
          grade = 2;
        } else {
          grade = 3;
        }
        return this.grades[grade];
      } else return 3;
    },

    totalGrade() {
      let array = [this.AAGrade, this.AGrade, this.BGrade, this.CGrade];
      if (this.failedOther || this.failedLength) {
        return this.grades[3];
      }
      return array.reduce((res, obj) => {
        return obj.value < res.value ? obj : res;
      });
    }
  },

  methods: {
    ...mapActions({
      searchServices: "repair/searchServices",
      getAllPrinters: "repair/getAllPrinters",
      printSortLabel: "repair/printSortLabel",
      submitGradeToOdoo: "repair/submitGrade",
      completeWatchRepair: "repair/completeWatchRepair"
    }),
    reset() {
      this.$store.commit("repair/setRepair", []);
      this.currentStep = 1;
      this.items = [];
      this.values = [];
      this.$router.push("/ipad-grading");
      this.otherStep = 1;
      this.failedOther = false;
      this.goToRevShare = false;
      this.goToVerizon = false;
      this.failedLength = false;
      this.noAPlus = false;
    },
    disableButton(sIndex) {
      let disabled = false;

      if (this.values.length && this.surfaces[sIndex].surface) {
        let keys = Object.keys(this.values[sIndex - 1]);

        keys.forEach(key => {
          let value = this.values[sIndex - 1][key];
          if (Number.isNaN(value) || value === "") {
            disabled = true;
          }
        });
      }

      return disabled;
    },
    handleOther() {
      this.otherStep++;
      this.failedOther = false;
    },
    valueSelected(index, q) {
      let step = this.currentStep - 1;
      if (step == 1) {
        if (index == 1) {
          this.noAPlus = true;
        } else if (index == 2) {
          this.failedLength = true;
        }

        this.currentSizeStatements = [];
        this.sizeDialog = false;
        this.currentStep++;
      } else if (step == 2) {
        if (q.id == 1) {
          if (index == 1) {
            this.noAPlus = true;
          } else if (index == 2) {
            this.failedLength = true;
          }
        } else if (q.id == 2) {
          if (index == 1) {
            this.noAPlus = true;
          } else if (index == 2) {
            this.failedLength = true;
          }
        } else if (q.id == 3) {
          if (index == 1) {
            this.failedLength = true;
          }
        } else if (q.id == 4) {
          if (index == 1) {
            this.failedLength = true;
          }
        }
        if (this.sizeStep < this.currentSizeStatements.length) {
          this.sizeStep++;
        } else {
          this.currentSizeStatements = [];
          this.sizeStep = 1;
          this.sizeDialog = false;
          this.currentStep++;
        }
      } else if (step == 3) {
        if (q.id == 1) {
          if (index == 1) {
            this.noAPlus = true;
          } else if (index == 2) {
            this.failedLength = true;
          }
        } else if (q.id == 2) {
          if (index == 1) {
            this.noAPlus = true;
          } else if (index == 2) {
            this.noAPlus = true;
          } else if (index == 3) {
            this.failedLength = true;
          }
        } else if (q.id == 3) {
          if (index == 1) {
            this.noAPlus = true;
          } else if (index == 2) {
            this.noAPlus = true;
          } else if (index == 3) {
            this.failedLength = true;
          }
        } else if (q.id == 4) {
          if (index == 1) {
            this.failedLength = true;
          }
        }
        if (this.sizeStep < this.currentSizeStatements.length) {
          this.sizeStep++;
        } else {
          this.currentSizeStatements = [];
          this.sizeDialog = false;
          this.sizeStep = 1;
          this.currentStep++;
        }
      } else if (step == 4) {
        if (q.id == 1) {
          if (index == 1) {
            this.noAPlus = true;
          } else if (index == 2) {
            this.failedLength = true;
          }
        } else if (q.id == 2) {
          if (index == 1) {
            this.noAPlus = true;
          } else if (index == 2) {
            this.failedLength = true;
          }
        } else if (q.id == 3) {
          if (index == 1) {
            this.failedLength = true;
          }
        } else if (q.id == 4) {
          if (index == 1) {
            this.failedLength = true;
          }
        }
        if (this.sizeStep < this.currentSizeStatements.length) {
          this.sizeStep++;
        } else {
          this.currentSizeStatements = [];
          this.sizeDialog = false;
          this.sizeStep = 1;
          this.currentStep++;
        }
      }
    },
    continueToNextStep(sIndex) {
      let step = sIndex - 1;
      let currentValues = this.values[step];
      if (this.totalGrade.value < 70) {
        this.currentStep++;
        return;
      }
      if (step == 0) {
        if (currentValues.scratch > 0 && currentValues.scratch <= 8) {
          this.currentSizeStatements.push({
            id: 1,
            name: "Scratches/Scuffs",
            statement: this.sizeStatement[0],
            statements: this.sizeQuestions[step].scratch
          });

          this.sizeDialog = true;
        } else {
          this.currentStep++;
        }
      } else if (step == 1) {
        if (currentValues.scratch > 0 && currentValues.scratch <= 8) {
          this.currentSizeStatements.push({
            id: 1,
            name: "Scratches/Scuffs",
            statement: this.sizeStatement[0],
            statements: this.sizeQuestions[step].scratch
          });
        }
        if (currentValues.nick > 0 && currentValues.nick <= 4) {
          this.currentSizeStatements.push({
            id: 2,
            name: "Nick/Gouges/Chips",
            statement: this.sizeStatement[1],
            statements: this.sizeQuestions[step].nick
          });
        }
        if (currentValues.dent > 0 && currentValues.dent <= 2) {
          this.currentSizeStatements.push({
            id: 3,
            name: "Dent",
            statement: this.sizeStatement[2],
            statements: this.sizeQuestions[step].dent
          });
        }
        if (
          currentValues.discoloration > 0 &&
          currentValues.discoloration <= 4
        ) {
          this.currentSizeStatements.push({
            id: 4,
            name: "Discoloration",
            statement: this.sizeStatement[3],
            statements: this.sizeQuestions[step].discoloration
          });
        }

        if (this.currentSizeStatements.length > 0) {
          this.sizeDialog = true;
        } else {
          this.currentStep++;
        }
      } else if (step == 2) {
        if (currentValues.scratch > 0 && currentValues.scratch <= 10) {
          this.currentSizeStatements.push({
            id: 1,
            name: "Scratches/Scuffs",
            statement: this.sizeStatement[0],
            statements: this.sizeQuestions[step].scratch
          });
        }
        if (currentValues.nick > 0 && currentValues.nick <= 4) {
          this.currentSizeStatements.push({
            id: 2,
            name: "Nick/Gouges/Chips",
            statement: this.sizeStatement[1],
            statements: this.sizeQuestions[step].nick
          });
        }
        if (currentValues.dent > 0 && currentValues.dent <= 3) {
          this.currentSizeStatements.push({
            id: 3,
            name: "Dent",
            statement: this.sizeStatement[2],
            statements: this.sizeQuestions[step].dent
          });
        }
        if (
          currentValues.discoloration > 0 &&
          currentValues.discoloration <= 3
        ) {
          this.currentSizeStatements.push({
            id: 4,
            name: "Discoloration",
            statement: this.sizeStatement[3],
            statements: this.sizeQuestions[step].discoloration
          });
        }

        if (this.currentSizeStatements.length > 0) {
          this.sizeDialog = true;
        } else {
          this.currentStep++;
        }
      } else if (step == 3) {
        if (currentValues.scratch > 0 && currentValues.scratch <= 10) {
          this.currentSizeStatements.push({
            id: 1,
            name: "Scratches/Scuffs",
            statement: this.sizeStatement[0],
            statements: this.sizeQuestions[step].scratch
          });
        }
        if (currentValues.nick > 0 && currentValues.nick <= 3) {
          this.currentSizeStatements.push({
            id: 2,
            name: "Nick/Gouges/Chips",
            statement: this.sizeStatement[1],
            statements: this.sizeQuestions[step].nick
          });
        }
        if (currentValues.dent > 0 && currentValues.dent <= 3) {
          this.currentSizeStatements.push({
            id: 3,
            name: "Dent",
            statement: this.sizeStatement[2],
            statements: this.sizeQuestions[step].dent
          });
        }
        if (
          currentValues.discoloration > 0 &&
          currentValues.discoloration <= 4
        ) {
          this.currentSizeStatements.push({
            id: 4,
            name: "Discoloration",
            statement: this.sizeStatement[3],
            statements: this.sizeQuestions[step].discoloration
          });
        }

        if (this.currentSizeStatements.length > 0) {
          this.sizeDialog = true;
        } else {
          this.currentStep++;
        }
      }
    },
    async submitGrade() {
      const res = await this.completeWatchRepair({
        id: this.repair[0].id,
        housing_grade: this.totalGrade.text,
        lcd_grade: this.totalGrade.text,
        final_grade: this.totalGrade.text,
        polished: false
      });
      if (res.success) {
        let grade = {
          grade_name: "iPad Grade",
          grade_result: this.totalGrade.text,
          grade_value: this.totalGrade.value,
          repair_id: this.repair[0].id,
          is_final: true
        };
        if (this.totalGrade.value > 60) {
          this.goToVerizon = true;
        } else {
          this.goToRevShare = true;
        }
        await this.submitGradeToOdoo({ grade });
        this.repairState = "done";
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: res.message,
          color: "red"
        });
      }
    },
    goBack() {
      if (this.failedLength) {
        window.location.reload();
      } else {
        this.currentStep--;
      }
    },
    async printLabel() {
      if (!this.selectedPrinter) {
        this.$store.dispatch("app/setSnackbar", {
          text: "Please Select a Printer!",
          color: "red"
        });
      } else {
        const res = await this.printSortLabel({
          repair_id: this.repair[0].id,
          printer: this.selectedPrinter
        });

        if (res.success) {
          this.$store.dispatch("app/setSnackbar", {
            text: "Sort label printed to " + this.selectedPrinter,
            color: "green"
          });
        } else {
          this.$store.dispatch("app/setSnackbar", {
            text: res.message,
            color: "red"
          });
        }
      }
    }
  }
};
</script>

<style>
.grade-circle {
  width: 400px;
  height: 400px;
  border-radius: 50%;
  font-size: 90px;
  line-height: 400px;
  text-align: center;
  border: 1px solid;
}
</style>
